import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { decode } from 'he';
import { cloneDeep } from 'lodash-es';

export class DecodingHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(response => {
        if (response instanceof HttpResponse) {
          const { body, url, status, statusText, headers } = response;
          // Bestanden (responseType 'blob', bv. de PDF van print/pdf) nooit "decoderen": cloneDeep
          // maakt van een Blob een leeg {} en de download faalt dan in URL.createObjectURL.
          if (body instanceof Blob || body instanceof ArrayBuffer) {
            return response;
          }
          if (typeof body === 'object') {
            const decodedBody = this.decodeRecursively(body);
            const decodedResponse = new HttpResponse({
              body: decodedBody,
              headers,
              status,
              statusText,
              url
            });
            return decodedResponse;
          }
        }

        return response;
      })
    );
  }

  private decodeRecursively(b: any): any {
    const body = cloneDeep(b);
    // eslint-disable-next-line guard-for-in
    for (const key in body) {
      const property = body[key];
      if (typeof property === 'string') {
        body[key] = decode(property);
      }

      if (typeof property === 'object') {
        body[key] = this.decodeRecursively(body[key]);
      }
    }
    return body;
  }
}
